import React, { useEffect, useRef, useState } from 'react'
import { withTheme } from 'theming'
import VerticalDeckSection from './verticalDeckSection'
import SectionalWithAdSection from './SectionalWithAdSection'
import { useSearchParams } from 'react-router-dom'

const VerticalStreamSectionalComponent = ({
  componentData,
  modifyData,
  setModalState,
  isEdit = true,
  theme,
  onAdd,
  pageURL,
}) => {
  const { data, id } = componentData
  const [playerData, setPlayerData] = useState({})
  const [shouldFocusPlayer, setShouldFocusPlayer] = useState(false)
  const playerContainerRef = useRef(null)
  const [searchParams] = useSearchParams()

  useEffect(() => {
    if (!shouldFocusPlayer || !playerContainerRef.current) return

    playerContainerRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
    playerContainerRef.current.focus({ preventScroll: true })
    setShouldFocusPlayer(false)
  }, [shouldFocusPlayer])

  const handlePlayerDataChange = (contentId) => {
    setPlayerData({ data: { id: contentId }, type: 'CONTENT' })
    setShouldFocusPlayer(true)
  }

  // Content redirected from the content detail page arrives as router state
  useEffect(() => {
    const contentId = searchParams.get('content_id')
    if (contentId) {
      handlePlayerDataChange(contentId)
    }
  }, [searchParams])

  let verticalComponentProps = {
    componentData: { data: data?.vertical_stream_data, id },
    modifyData: modifyData,
    setModalState: setModalState,
    isEdit: isEdit,
    playerData: playerData,
    setPlayerData: setPlayerData,
    playerContainerRef: playerContainerRef,
    pageURL: pageURL,
  }
  let sectionalWithAdProps = {
    componentData: { data: data?.sectional_component_data, id },
    modifyData: modifyData,
    setModalState: setModalState,
    isEdit: isEdit,
    onAdd: onAdd,
    pageURL: pageURL,
  }

  return (
    <div className="w-full">
      <VerticalDeckSection {...verticalComponentProps} />
      <SectionalWithAdSection {...sectionalWithAdProps} />
    </div>
  )
}

export default withTheme(VerticalStreamSectionalComponent)
